import React from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  fab,
  faTwitterSquare,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"

library.add(fab, faTwitterSquare, faTwitter)

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <div>
        <main>{children}</main>
      </div>
    )
  }
}

export default Layout
